/*
 * @Author: Fan
 * @Date: 2020-04-18 21:23:13
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
import { inputControlOptions, TextAreaType, } from "../../../../form/component-schema";
export default {
    $id: "longText",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        defaultValue: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
        },
        textAreaType: {
            type: DataType.String,
            title: i18n.t('dataitem.InputBoxStyle').toString(),
            default: TextAreaType.LongText,
        },
        maxLength: {
            type: DataType.Integer,
            title: i18n.t('dataitem.MaxLength').toString(),
            default: 2e3,
        },
        currentMaxLength: {
            type: DataType.Integer,
            title: i18n.t('dataitem.WordLimit').toString(),
            default: 2e6,
        },
        placeholder: {
            type: DataType.String,
            title: i18n.t('dataitem.Placeholder').toString(),
            default: i18n.t('dataitem.InputPlaceholder').toString(),
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
